import React from 'react'

import { Modal } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { RecipeCoreId, RecipeUUID } from '@library/menu-service'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { DetailContent as DetailContentExperience } from 'routes/Menu/MenuExperience/Detail/DetailContent'

import { DetailContent } from './DetailContent'

import css from './Detail.css'

type DetailProps = {
  uuid: RecipeUUID
  coreId: RecipeCoreId
  title: string
  showOverlay: boolean
  isExperienceDetailEnabled: boolean
  error: boolean
  loading: boolean
  recipe: MenuRecipe | RecipeQueryResponse | null
  position?: string
  reload: () => void
  onClose: () => void
  isScrollableBasketEnabled: boolean
}

export const Detail = ({
  uuid,
  coreId,
  title,
  showOverlay,
  isExperienceDetailEnabled,
  error,
  loading,
  recipe,
  reload,
  onClose,
  position,
  isScrollableBasketEnabled,
}: DetailProps) => (
  <Modal
    name="recipe-detail-modal"
    isOpen={showOverlay}
    onRequestClose={onClose}
    overlayClassName={css.overlay}
  >
    {isExperienceDetailEnabled ? (
      <DetailContentExperience
        uuid={uuid}
        coreId={coreId}
        title={title}
        error={error}
        loading={loading}
        recipe={recipe?.responseType === 'experience' ? recipe : null}
        reload={reload}
        onClose={onClose}
        position={position}
        isScrollableBasketEnabled={isScrollableBasketEnabled}
      />
    ) : (
      <DetailContent
        uuid={uuid}
        coreId={coreId}
        title={title}
        error={error}
        loading={loading}
        recipe={recipe?.responseType === 'v3' ? recipe : null}
        reload={reload}
        onClose={onClose}
        position={position}
        isScrollableBasketEnabled={isScrollableBasketEnabled}
      />
    )}
  </Modal>
)
